import { jsx as _jsx } from "react/jsx-runtime";
import { MediaContent } from './media-content';
const mediaFillClasses = 'h-full [&_img]:h-full [&_img]:w-full [&_img]:object-cover [&_video]:h-full [&_video]:w-full [&_video]:object-cover';
/**
 * Absolutely-fills the nearest positioned ancestor with `media` (image or video), for components
 * that overlay content on top of a full-bleed background — shared by `BillboardHero`, `SplitHero`,
 * `Card`, and `Tile` so the discriminated-union rendering and the motion-safe/motion-reduce
 * poster-fallback pattern aren't duplicated per consumer. Rendering itself lives in `MediaContent`.
 */
export const MediaFill = ({ media }) => (_jsx("div", { className: "absolute inset-0 -z-10", children: _jsx(MediaContent, { media: media, className: mediaFillClasses }) }));
